import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_COST_FILE_TEMPLATE_STEP = 'UPDATE_COST_FILE_TEMPLATE_STEP' as const;

export const updateCostFileTemplateStep = (step: string) => ({
  data: { step },
  type: UPDATE_COST_FILE_TEMPLATE_STEP,
});

export type UpdateCostFileTemplateStepAction = DataAction<typeof UPDATE_COST_FILE_TEMPLATE_STEP, { step: string }>;
